export const TRANSFER_STATUS = {
  FORWARD: "FORWARD",
  COMPLETED: "COMPLETED",
  INITIATED: "INITIATED",
  SENT_FOR_DOCUMENTS_UPLOAD: "SENT_FOR_DOCUMENTS_UPLOAD",
  UPLOADED_NOC: "UPLOADED_NOC",
  UPLOADED_JOINING_LETTER: "UPLOADED_JOINING_LETTER",
  NEED_TO_VERIFIED: "NEED_TO_VERIFIED",
};

export const RETIREMENT_STATUS = {
  DRAFT: "DRAFT",
  INITIATED: "INITIATED",
  SENT_FOR_APPROVAL: "SENT_FOR_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  ACTION_NEEDED: "ACTION_NEEDED",
};

export const RESIGNATION_STATUS = {
  DRAFT: "DRAFT",
  INITIATED: "INITIATED",
  SENT_FOR_APPROVAL: "SENT_FOR_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  ACTION_NEEDED: "ACTION_NEEDED",
};

export const LEAVE_STATUS = {
  DRAFT: "DRAFT",
  INITIATED: "INITIATED",
  SENT_FOR_APPROVAL: "SENT_FOR_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  ACTION_NEEDED: "ACTION_NEEDED",
};

export const MAINTENANCE_STATUS = {
  FIXED: "FIXED",
  PENDING: "PENDING",
};

export const PROMOTION_STATUS = {
  DRAFT: "DRAFT",
  REFUSE: "REFUSE",
  RECOMMEND: "RECOMMEND",
};

export const TICKET_STATUS = {
  OPEN: "OPEN",
  ON_GOING: "ON GOING",
  SOLVED: "SOLVED",
  CLOSED: "CLOSED",
};
export const CONDITION_STATUS = {
  WASTAGE: "WASTAGE",
  GOOD: "GOOD",
  DAMAGE: "DAMAGE",
  STOLEN: "STOLEN",
  BAD: "BAD",
  OLD: "OLD",
  NEW: "NEW",
};

export const FILE_INQUIRY_STATUS = {
  PENDING_FOR_REVIEW: "PENDING_FOR_REVIEW",
  UNASSIGNED: "UNASSIGNED",
};

export const STATUS = {
  DONE: "DONE",
  SUBMITTED: "SUBMITTED",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  PROCESS_STARTED: "PROCESS_STARTED",
  APPLIED: "APPLIED",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  SUSPENDED: "SUSPENDED",
  ...FILE_INQUIRY_STATUS,
  ...LEAVE_STATUS,
  ...RESIGNATION_STATUS,
  ...RETIREMENT_STATUS,
  ...TRANSFER_STATUS,
  ...MAINTENANCE_STATUS,
  ...PROMOTION_STATUS,
  ...TICKET_STATUS,
  ...CONDITION_STATUS,
};
